import React from 'react';

const LandingPageCalls = () => (
    <div className="flex flex-auto border-s border-solid bg-white" />
);

export default LandingPageCalls;
